module.exports = __webpack_public_path__ + "img/3.702e8eab.png";